import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import clarity from "@microsoft/clarity";

// Microsoft Clarity (solo si está configurado el Project ID)
const clarityProjectId = process.env.REACT_APP_CLARITY_PROJECT_ID;
if (clarityProjectId) {
  clarity.init(clarityProjectId);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.Fragment>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.Fragment>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
